import { Injectable } from "@angular/core";
import { IntakeService } from "app/intake/intake-services/intake.service";

@Injectable({
    providedIn: 'root',
})

export class DateService {
    constructor(private intakeService:IntakeService) {

    }
    public getDate(date){
        return this.getLocaleDate(date);
    }
    
    public getLocaleDate(date: Date) {
        if(date!=null && (this.isIsoDate(date.toString()) ||  date.toString().indexOf('GMT') ==-1 ))
        {
          return this.intakeService.getLocalDate(date);
        }
        return date;
    }
    
    public isIsoDate(dateStringToCompare) {
        return new Date(dateStringToCompare).toISOString() === dateStringToCompare;
    }
    public getLocalISODateFormat(localDate: Date)
    {
      if(localDate!= null)
      {
        if(!(localDate instanceof Date)) localDate = new Date(localDate);

        let date = localDate.getDate().toString();
        let month = (localDate.getMonth()+1).toString();
        let hours = localDate.getHours().toString();
        let mins = localDate.getMinutes().toString();
        const year = localDate.getFullYear();
    
        if(date.length == 1)  date =  `0${date}`;
        if(month.length == 1) month = `0${month}`;
        if(hours.length == 1) hours = `0${hours}`;
        if(mins.length == 1)  mins = `0${mins}`;
    
      return `${year}-${month}-${date}T${hours}:${mins}:00.000Z`;
      }
      return localDate;
    }
    public getFormatedDateFromAPI(date: string)
    {
      if(date != null)
      {
        return new Date(date.slice(0,16));
      }
      return date;
    }
}